export class Doc {
    constructor(
            public id: number  = null,
            public name: string = '',
            public status: boolean = true) {}
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_classes/list/doc.ts